<template>
  <div>
    <a href="#" @click.prevent="modalVisible = true">Didn't get your offer?</a>

    <v-dialog :value="modalVisible" persistent max-width="350">
      <v-card>
        <v-card-title class="headline">Didn't get your offer?</v-card-title>
        <v-card-text>
          <p>We're sorry to hear that the offer didn't work.</p>
          <p>Please tell us what happened and we'll remove this offer from your list.</p>
          <v-select
            v-model="selectedProblemType"
            dense
            outlined
            class="mt-6"
            label="What went wrong?"
            item-text="value"
            item-value="type"
            :items="problemTypes"
            :loading="loadingProblemTypes"
            :disabled="submitProblemLoading"
          />
          <v-textarea v-model="problemTypeComments" label="Tell us more" :disabled="submitProblemLoading" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text :disabled="submitProblemLoading" @click="modalVisible = false">Cancel</v-btn>
          <v-btn color="primary darken-1" text :disabled="reportProblemButtonDisabled" :loading="submitProblemLoading" @click="submitVoucherProblem">
            Report Problem
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'

import { ApiService } from '../services'

export default Vue.extend({
  name: 'OfferReportProblem',

  props: {
    voucherId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    modalVisible: false,
    problemTypes: [],
    selectedProblemType: null,
    problemTypeComments: '',
    loadingProblemTypes: true,
    submitProblemLoading: false,
  }),

  computed: {
    reportProblemButtonDisabled() {
      return this.loadingProblemTypes || !this.selectedProblemType || (this.selectedProblemType === 'OTHER' && this.problemTypeComments === '')
    },
  },

  mounted: function () {
    ApiService.get('voucherWorkflow/problemTypes').then((response) => {
      this.loadingProblemTypes = false
      this.problemTypes = response.data
    })
  },

  methods: {
    submitVoucherProblem() {
      this.submitProblemLoading = true

      ApiService.post(`voucherWorkflow/reportProblem/${this.voucherId}`, {
        problemType: this.selectedProblemType,
        comments: this.problemTypeComments,
      }).then(() => {
        this.$store.dispatch('reservations/fetchReservationSummary')

        this.$toast.success("Thanks! We've removed this offer from your active offers")
        this.$router.push({ path: '/' })
      })
    },
  },
})
</script>
